import { render, staticRenderFns } from "./ClazzPanel.vue?vue&type=template&id=46635c5f&scoped=true&"
import script from "./ClazzPanel.vue?vue&type=script&lang=js&"
export * from "./ClazzPanel.vue?vue&type=script&lang=js&"
import style0 from "./ClazzPanel.vue?vue&type=style&index=0&id=46635c5f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46635c5f",
  null
  
)

export default component.exports